
import { Quote, Star } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

const testimonials = [
  {
    quote: "Väga ülevaatlik, VAJALIK ja informatiivne koolitus tänapäeva kiires infoühiskonnas tegutsevale inimesele.",
    author: "Liisi"
  },
  {
    quote: "Väga hea koolitus. Tekib inimeste mõistmine ja oskad ise reageerida rohkem mõistusega keerulistele käitumismustritele. Soovitan kõigile tõesti! Silmi avardav.",
    author: "Sandra"
  },
  {
    quote: "Koolitus oli väga kergesti jälgitav ning äärmiselt põnev ja kaasahaarav, kuulamise kõrval sai pilgu endasse heita ning leida nii mitmeidki äratundmise kohti. Mul on heameel, et sain koolitusest osa. Tänan, Kaija!",
    author: "Elika"
  }
];

const Testimonials = () => {
  return (
    <div className="mb-12">
      <Carousel className="w-full">
        <CarouselContent>
          {testimonials.map((testimonial, index) => (
            <CarouselItem key={index}>
              <div className="p-1">
                <Card className="bg-gradient-to-br from-white to-kaija-light/50 border-kaija-sage/20">
                  <CardContent className="pt-8 pb-6 px-8">
                    <div className="flex items-start mb-4">
                      <Quote className="h-8 w-8 text-kaija-slate mr-3 flex-shrink-0 rotate-180" />
                      <p className="italic text-gray-700 text-lg">
                        "{testimonial.quote}"
                      </p>
                    </div>
                    <Separator className="my-4 bg-kaija-sage/30" />
                    <div className="flex justify-between items-center">
                      <p className="font-medium text-kaija-slate">{testimonial.author}</p>
                      <div className="flex">
                        {[...Array(5)].map((_, i) => (
                          <Star key={i} className="h-4 w-4 text-amber-500 fill-amber-500" />
                        ))}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="border-kaija-slate text-kaija-slate" />
        <CarouselNext className="border-kaija-slate text-kaija-slate" />
      </Carousel>
    </div>
  );
};

export default Testimonials;
